import { AuroraThemeColors } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/theme/auroraColors'
import { ThemeColors } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/theme/colors'

import { getButtonStyles } from './buttonStyles'

export const getAuroraButtonStyles = (tokenColors: ThemeColors) => {
  const defaultButtonStyles = getButtonStyles(tokenColors)
  const auroraColors = tokenColors as AuroraThemeColors

  return {
    ...defaultButtonStyles,
    primary: {
      ...defaultButtonStyles.primary,
      cobaltLight: {
        base: {
          backgroundColor: auroraColors.primaryButtonCobaltLightBackgroundDefault,
          color: auroraColors.primaryButtonCobaltLightTextActive,
          minWidth: 100,
        },
        sizes: {
          default: {
            height: 48,
            paddingHorizontal: 23,
          },
          small: {
            height: 40,
            paddingHorizontal: 15,
          },
          unsized: {},
        },
        states: {
          hovered: {
            backgroundColor: auroraColors.primaryButtonCobaltLightBackgroundHover,
          },
          pressed: {
            backgroundColor: auroraColors.primaryButtonCobaltLightBackgroundPressed,
          },
          inactive: {
            color: auroraColors.primaryButtonCobaltLightTextInactive,
            backgroundColor: auroraColors.primaryButtonCobaltLightBackgroundInactive,
          },
          loading: {
            backgroundColor: auroraColors.primaryButtonCobaltLightBackgroundLoading,
          },
        },
        focused: {
          backgroundColor: auroraColors.primaryButtonCobaltLightBackgroundFocus,
        },
      },
    },
    wordCloud: {
      ...defaultButtonStyles.wordCloud,
      default: {
        ...defaultButtonStyles.wordCloud.default,
        base: {
          ...defaultButtonStyles.wordCloud.default.base,
          borderRadius: 60,
          borderWidth: 1,
          borderColor: tokenColors.wordCloudButtonOutlineDefault,
          backgroundColor: tokenColors.wordCloudButtonBackgroundDefault,
          backdropFilter: 'blur(4px)',
        },
      },
    },
  }
}
